export const SERVICE_WORKER_PATH = '/sw.js';

export function isServiceWorkerSupported() {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator;
}

/**
 * Tells the service worker which membership is active so it only shows pushes
 * meant for it. Pass `null` to clear it (e.g. on sign out).
 */
export function postActiveMembership(
  worker: ServiceWorker | null | undefined,
  membershipId: string | null
) {
  worker?.postMessage(
    JSON.stringify({
      type: 'setActiveMembership',
      payload: membershipId,
    })
  );
}

/**
 * Triggers a test message, part of the user-initiated registration flow.
 */
export function postTestMessage(worker: ServiceWorker | null | undefined) {
  worker?.postMessage(
    JSON.stringify({
      type: 'testMessage',
    })
  );
}

/**
 * Best-effort clear of the active membership. Uses getRegistration rather than
 * `ready` because `ready` never resolves when no worker was ever registered.
 */
export async function clearActiveMembership() {
  if (!isServiceWorkerSupported()) {
    return;
  }
  const registration =
    await navigator.serviceWorker.getRegistration(SERVICE_WORKER_PATH);
  postActiveMembership(registration?.active, null);
}

/**
 * Triggers a test notification message
 */
export async function triggerTestNotification() {
  if (!isServiceWorkerSupported()) {
    return;
  }
  const registration =
    await navigator.serviceWorker.getRegistration(SERVICE_WORKER_PATH);
  postTestMessage(registration?.active);
}
